export default __webpack_public_path__ + "static/media/Acedol-SR-ban.7b3b1e5b.jpg";